import { createRecipe } from './runtime.js';

const tableTruncateConfig = {"name":"tableTruncate","className":"table-truncate","variantMap":{"mode":["end","middle","none","start"]}}

export const tableTruncate = /* @__PURE__ */ createRecipe(tableTruncateConfig)